import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonSnackBarService } from 'src/app/_services/common-snack-bar.service';
import { ReportTemplateList } from '../_objects/report-template';
import { ReportTemplateDesignService } from '../_services/report-template-design.service';
import { ReportTemplateService } from '../_services/report-template.service';
import { REPORT_TEMPLATE___APPLICATION_TYPE, StorageService } from '../_services/storage.service';
import { AddNewTemplateDialogComponent } from '../common-dialog/add-new-template-dialog/add-new-template-dialog.component';
import { CommonDeleteDialogComponent } from '../common-dialog/common-delete-dialog/common-delete-dialog.component';
import { CommonErrorMessageDialogComponent } from '../common-dialog/common-error-message-dialog/common-error-message-dialog.component';
import { ImportNewTemplateDialogComponent } from '../common-dialog/import-new-template-dialog/import-new-template-dialog.component';
import {
  ReportTemplateImageUploadDialogComponent
} from '../common-dialog/report-template-image-upload-dialog/report-template-image-upload-dialog.component';

import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilsService } from '../_services/_utils.service';
import { TenantUserList } from '../_objects/user';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';
import { SpinnerService } from '@osc-utils/services/spinner.service';

export class ReportTemplatesListWrapper extends ReportTemplateList {
  lastUpdatedByName = '';

  constructor(item: ReportTemplateList, inspectorName: string) {
    super();
    this.id = item.id;
    this.name = item.name;
    this.reportTitleInputMode = item.reportTitleInputMode;
    this.reportTitleFormat = item.reportTitleFormat;
    this.application = item.application;
    this.templateUrl = item.templateUrl;
    this.createdByTenantId = item.createdByTenantId;
    this.createdByUserId = item.createdByUserId;
    this.lastUpdatedDateUtc = item.lastUpdatedDateUtc;
    this.lastUpdatedByUserId = item.lastUpdatedByUserId;
    this.reportTemplateContent = item.reportTemplateContent;
    this.subjectModelIds = item.subjectModelIds;
    this.action = item.action;
    this.reportType = item.reportType;
    this.equipmentTypes = item.equipmentTypes;
    this.equipmentType = item.equipmentType;
    this.apiCode = item.apiCode;
    this.isValid = item.isValid;

    this.lastUpdatedByName = inspectorName;
  }
}

@Component({
  selector: 'app-report-template',
  templateUrl: './report-template.component.html',
  styleUrls: ['./report-template.component.scss', '../common-sidenavi/common-sidenavi-container.scss'],
  standalone: false
})

export class ReportTemplateComponent implements OnInit {

  @ViewChild(MatSort) public sort: MatSort;
  public reportTemplatesListDataSource: MatTableDataSource<ReportTemplateList> = new MatTableDataSource<ReportTemplateList>();
  public displayedColumns: string[];
  public reportTemplates: ReportTemplateList[];
  public isLoading: boolean;
  public isVisol = false;
  public LastUpdatedBy = null;
  private tenantUsers: TenantUserList[];

  public isTemplateEditable: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reportTemplateService: ReportTemplateService,
    private designService: ReportTemplateDesignService,
    private dialog: MatDialog,
    private utilsService: UtilsService,
    private spinnerService: SpinnerService,
    private storageService: StorageService,
    private snackBar: CommonSnackBarService,
    private translate: TranslateService,
    private langService: LangUpdateService

  ) { this.langService.prepare(this, this.translate); }

  public ngOnInit() {
    const applicationType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);
    if (applicationType) {
      this.isVisol = applicationType.IsVisol;
    }

    this.displayedColumns = this.isVisol ? ['name', 'application', 'lastUpdatedDateUtc', 'lastUpdatedBy', 'action']
      : ['name', 'application', 'reportType', 'equipmentType', 'lastUpdatedDateUtc', 'lastUpdatedBy', 'action'];

    this.isTemplateEditable = true;
    this.getUsers().subscribe(res => {
      this.tenantUsers = res;
      this.getReportTemplatesList();
    })
  }

  public getReportTemplatesList() {
    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    this.isLoading = true;
    this.reportTemplateService.getReportTemplates(this.isVisol, null, false).subscribe((rt) => {
      this.reportTemplates = rt;
      if (this.reportTemplates.length > 0) {
        const viewData = this.reportTemplates.map(reportTemplate => {
          const wrap = new ReportTemplatesListWrapper(reportTemplate, null);
          wrap.lastUpdatedByName = this.getLastUpdatedByName(reportTemplate);
          return wrap;
        })
        this.reportTemplatesListDataSource.data = viewData;
      }
      this.isLoading = false;
      this.spinnerService.hide(this.spinnerService.mainSpinnerId);
    }, (error) => {
      this.isLoading = false;
      this.spinnerService.hide(this.spinnerService.mainSpinnerId);
    });
  }

  public editReportTemplate(reportTemplate?: ReportTemplateList) {
    if (!this.isTemplateEditable) {
      return;
    }
    this.designService.reportTemplateId = reportTemplate.id;
    this.router.navigateByUrl(`/report-template-design/${reportTemplate.id}`);
  }

  public openNewTemplateDialog(): void {
    const dialogRef = this.dialog.open(AddNewTemplateDialogComponent, {
      data: {
        width: '90%', height: '90%',
        action: 'add', template: {}
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getReportTemplatesList();
      }
    });
  }

  public convertUTCTimeToLocal(UTCtime: string) {
    return new Date(UTCtime + 'Z')
  }

  public openImageUploadDialog() {
    const dialogRef = this.dialog.open(ReportTemplateImageUploadDialogComponent, {
      width: '800px',
      height: '90%',
      autoFocus: false
    });
    dialogRef.componentInstance.changeImages.subscribe(() => {
      this.designService.loadReportTemplateImages();
    });
  }

  public openErrorMessageDialog(firstMessage: string, secondMessage: string): void {
    const dialog = this.dialog.open(CommonErrorMessageDialogComponent, {
      width: '450px',
      height: '326px',
      data: { firstMessage, secondMessage }
    });
  }

  public deleteTemplate(template: ReportTemplateList, event: any): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(CommonDeleteDialogComponent, {
      width: '600px',
      minWidth: '400px',
      maxHeight: '800px',
      data: { target: this.translate.instant('reporttemplateComponent.template'), deleteNames: [template.name] }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinnerService.show(this.spinnerService.mainSpinnerId);
        this.reportTemplateService.deleteReportTemplate(template.id, this.isVisol).subscribe(
          value => { },
          (error: HttpErrorResponse) => {
            this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            if (error.status === 409) {
              this.openErrorMessageDialog(this.translate.instant('reporttemplateComponent.deleteFailed'), this.translate.instant('reporttemplateComponent.reportusestemplate'));
            } else {
              console.log('error');
            }
          },
          () => {
            this.getReportTemplatesList();
          }
        );
      }
    });
  }

  public cloneTemplate(template: ReportTemplateList, event: any): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(AddNewTemplateDialogComponent, {
      data: { action: 'clone', template }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getReportTemplatesList();
      }
    });
  }

  public editTemplate(template: ReportTemplateList, event: any): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(AddNewTemplateDialogComponent, {
      data: { action: 'edit', template }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getReportTemplatesList();
      }
    });
  }

  public importReportTemplate(files: File[], reportTemplate: ReportTemplateList): void {
    // if (!files || files.length !== 1) {
    //  throw new ApplicationError('Files are invalid.');
    // }

    const file = files[0];

    this.openImportConfirmDialog(file.name, reportTemplate).subscribe(val => {
      if (val.result) {
        this.spinnerService.show(this.spinnerService.mainSpinnerId);
        this.reportTemplateService.importReportTemplate(file, reportTemplate).subscribe(
          value => { },
          (error: HttpErrorResponse) => {
            this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            if (error.status === 400) {
              this.openErrorMessageDialog(this.translate.instant('reporttemplateComponent.importfailed'),
                this.translate.instant('reporttemplateComponent.checkandtry'));
            } else {
              this.snackBar.open(this.translate.instant('reporttemplateComponent.importfailed'));
              console.log(error);
            }
          },
          () => {
            this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            this.snackBar.open(this.translate.instant('reporttemplateComponent.importsuccessfully'));
            this.getReportTemplatesList();
          }
        );
      }
    });
  }

  public importReportTemplateAsync(files: File[]): void {
    // if (!files || files.length !== 1) {
    //  throw new ApplicationError('Files are invalid.');
    // }

    const file = files[0];

    this.openImportReportTemplateConfirmDialog(file.name, null).subscribe(val => {
      // this.oscSpinnerService.show();
      if (val.result) {
        this.spinnerService.show(this.spinnerService.mainSpinnerId);
        this.reportTemplateService.importReportTemplateAsync(file).subscribe(res => {
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
          if (res) {
            this.snackBar.open(this.translate.instant('reporttemplateComponent.importsuccessfully'));
            this.getReportTemplatesList();
          } else {
            this.openErrorMessageDialog(this.translate.instant('reporttemplateComponent.importfailed'),
              this.translate.instant('reporttemplateComponent.checkandtry'));
          }
        })

      }
    });
  }

  public exportReportTemplate(template: ReportTemplateList) {
    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    this.reportTemplateService.exportReportTemplate(template.id, this.isVisol)
      .subscribe(
        blob => {
          this.utilsService.download(blob, template.name + '.zip', null);
        },
        error => {
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
          this.snackBar.open(this.translate.instant('reporttemplateComponent.importfailed'));
          console.log(error);
        },
        () => {
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        });
  }

  public openImportConfirmDialog(filename: string, reportTemplate: ReportTemplateList): Observable<{ result: boolean }> {
    const dialogRef = this.dialog.open(ImportNewTemplateDialogComponent, {
      width: '550px',
      height: '400px',
      data: { reportTemplate, filename }
    });
    return dialogRef.afterClosed();
  }

  public openImportReportTemplateConfirmDialog(filename: string, reportTemplate: ReportTemplateList): Observable<{ result: boolean }> {
    const dialogRef = this.dialog.open(ImportNewTemplateDialogComponent, {
      width: '550px',
      height: '400px',
      data: { reportTemplate, filename }
    });
    return dialogRef.afterClosed();
  }

  public getEquipmentTypesString(equipmentTypes: string[]): string {
    return Array.isArray(equipmentTypes)
      ?
      equipmentTypes.map((r) => { return this.translate.instant('objects.' + r); }).join('\n') :
      (equipmentTypes ?
        (equipmentTypes as string).split(',').map((r) => { return this.translate.instant('objects.' + r.replace('&amp;', '&')); }).join(',') :
        '');
  }

  public getEquipmentType(equipmentTypes: string): string {
    return equipmentTypes.split(',').length > 1 ? this.translate.instant('objects.' + equipmentTypes.split(',')[0]) + '...' : this.translate.instant('objects.' + equipmentTypes);
  }

  private getLastUpdatedByName(item: ReportTemplateList): string {
    const user = this.tenantUsers.find(_ => _.id === item.lastUpdatedByUserId);
    return user
      ? user.givenName + ' ' + user.surname
      : this.translate.instant('reporttemplateComponent.unknownUser');
  }

  private getUsers(): Observable<TenantUserList[]> {
    return this.reportTemplateService.getUsers();
  }
}
